(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Wishlist heart in the header. Swishlist only ships a floating corner button and no public
     API, so the heart forwards its click to that button — the app opens its own drawer and
     keeps owning the list. The button is parked off-screen by CSS (not removed: it has to stay
     in the DOM for the app's handler to work), and the app re-renders it whenever the list
     changes, hence the observer. */
  class WishlistIcon extends HTMLElement {
    connectedCallback() {
      this.selector = (this.dataset.appSelector || '').trim();
      if (!this.selector) return;

      this.button = this.querySelector('button');
      this.bubble = this.querySelector('.wishlist-count-bubble');
      this.counter = this.querySelector('[data-wishlist-count]');

      this.onClick = this.onClick.bind(this);
      this.button?.addEventListener('click', this.onClick);

      this.sync();
      // The observer watches the whole body, so coalesce bursts into one sync per frame.
      this.observer = new MutationObserver(() => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.sync();
        });
      });
      this.observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    get appButton() {
      return document.querySelector(this.selector);
    }

    onClick() {
      this.appButton?.click();
    }

    // Show the heart only once the app is on the page, and mirror the count it renders.
    sync() {
      const appButton = this.appButton;
      this.classList.toggle('header__icon-wishlist-wrapper--ready', !!appButton);
      if (!appButton || !this.bubble) return;

      // Swishlist keeps the number in .st-number[data-count]; fall back to the button's text.
      const number = appButton.querySelector('.st-number');
      const count = number
        ? number.dataset.count || number.textContent.trim()
        : (appButton.textContent.match(/\d+/) || [])[0];
      if (count && count !== '0') {
        this.counter.textContent = count;
        this.bubble.hidden = false;
      } else {
        this.counter.textContent = '';
        this.bubble.hidden = true;
      }
    }
  }

  customElements.define('wishlist-icon', WishlistIcon);

  } catch(e) { console.error(e); }
})();
})();
